import { isBrowser } from '@sortlist-frontend/utils';
import { getCookie } from 'cookies-next';

export function getBrowserLocale() {
  if (!isBrowser()) return;
  return navigator.languages?.[0] ?? navigator.language;
}

export function getGbuuid(): string | undefined {
  const gbuuid = getCookie('gbuuid')?.toString();

  return gbuuid ?? undefined;
}

export function getDomain() {
  if (!isBrowser()) {
    return undefined;
  }
  return location.hostname.includes('.') ? location.hostname.replace(/^[^.]+(?=\.)/, '') : undefined;
}
